import { AxiosInstance } from 'axios'

import { updateAccount } from '@percent/workplace-giving/api/account/updateAccount/updateAccount'
import { Account } from '@percent/workplace-giving/context/auth/authContext/AuthContext.types'

/**
 * Updates account's preferred language if browser language differs from stored one
 */
export const maybeUpdatePreferredLanguage = async (client: AxiosInstance, account: Account): Promise<Account> => {
  const browserLanguage = navigator.language

  if (!browserLanguage) {
    return account
  }

  if (account.preferredLanguage !== browserLanguage) {
    try {
      return await updateAccount(client, { preferredLanguage: browserLanguage })
    } catch (error) {
      // If language update fails, continue with original account data to not block login flow
      // eslint-disable-next-line no-console
      console.warn('Failed to update preferred language:', error)

      return account
    }
  }

  return account
}
